import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconEdit, IconPlus, IconTrash } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_Row,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { _localization } from "../../../../../../config/location";
import {
  tblPromotion,
  tblPromotionItemGiftCommand,
} from "../../../../../../model/TblPromotion";
import ModalItemGiftEditDiscount from "../../Modals/ModalItemGiftEditDiscount";
import ModalDiscountToAll from "../../Modals/ModalItemPrimaryDiscountToAll";
import ModalSearchItems from "../../Modals/SearchItems";

const TableItemGiftPromotion = ({
  form,
}: {
  form: UseFormReturnType<tblPromotion, (values: tblPromotion) => tblPromotion>;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [data, setData] = useState<tblPromotionItemGiftCommand[]>([]);
  const [dataTemp, setDataTemp] = useState<tblPromotionItemGiftCommand[]>([]);

  const entity: tblPromotionItemGiftCommand = {
    id: 0,
    promoteId: null,
    promoteDetailId: null,
    idItemPrimary: null,
    idItemGift: null,
    quantityApply: null,
    quantityMin: null,
    quantityMax: null,
    discountPercent: null,
    discountAmount: null,
    price: null,
    priceMin: null,
    priceMax: null,
    // attribute1: null,
    // attribute2: null,
    // attribute3: null,
    // attribute4: null,
    // attribute5: null,
    // attribute6: null,
    // attribute7: null,
    // attribute8: null,
    // attribute9: null,
    // attribute10: null,
    // attribute11: null,
    // attribute12: null,
    // attribute13: null,
    // attribute14: null,
    // attribute15: null,
    itemGiftCode: null,
    itemGiftName: null,
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemGiftCode",
        header: "Mã hàng",
        size: 80,
      },
      {
        accessorKey: "itemGiftName",
        header: "Tên hàng",
        Cell: ({ renderedCellValue, cell }) => (
          <Tooltip label={renderedCellValue as string}>
            <Text truncate="end" w={500} size="11.5px">
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "quantityApply",
        header: "SL cho phép",
        enableGlobalFilter: false,
        size: 80,
      },
      {
        accessorKey: "quantityMax",
        header: "SLượng tối đa 1 lần được mua/1 Đ.Hàng",
        enableGlobalFilter: false,
      },
      {
        accessorKey: "attribute2",
        header: "Quà tặng tương đương",
        enableGlobalFilter: false,
        Cell: ({ renderedCellValue, cell }) => (
          <Tooltip label={renderedCellValue as string}>
            <Text truncate="end" w={300} size="11.5px">
              {renderedCellValue}
            </Text>
          </Tooltip>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableGlobalFilter: false,
        enableColumnActions: false,
        enableSorting: false,
        size: 100,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {processTaskActionMenu(row)}
          </Box>
        ),
      },
    ],
    []
  );

  function processTaskActionMenu(row: MRT_Row<any>): any {
    return (
      <>
        <Tooltip label="Sửa chiết khấu">
          <ActionIcon variant="light" aria-label="Settings" color="yellow">
            <IconEdit
              size={14}
              stroke={1.5}
              onClick={() => openModalItemGiftEditDiscount(row.original)}
            />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Xóa sản phẩm">
          <ActionIcon
            variant="light"
            aria-label="Settings"
            color="red"
            onClick={() => deletesData([row.id])}
          >
            <IconTrash size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </>
    );
  }

  const openSearchItems = () => {
    modals.openConfirmModal({
      size: "70vw",
      centered: true,
      title: <Title order={5}>Tìm kiếm mặt hàng</Title>,
      children: <ModalSearchItems handleAddSearchItem={handleAddSearchItem} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModalDiscountToAll = () => {
    modals.openConfirmModal({
      size: "550px",
      title: <Title order={5}>Nhập chiết khấu</Title>,
      children: (
        <ModalDiscountToAll
          appleDiscountToAll={appleDiscountToAll}
          itemType="gift"
          typePromotion="1"
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openModalItemGiftEditDiscount = (
    dataEdit: tblPromotionItemGiftCommand
  ) => {
    modals.openConfirmModal({
      size: "700px",
      title: <Title order={5}>Nhập chiết khấu</Title>,
      children: (
        <ModalItemGiftEditDiscount
          dataEdit={dataEdit}
          editItemDiscount={editItemDiscount}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleAddSearchItem = (selectItem: any[]) => {
    const newData: tblPromotionItemGiftCommand[] = selectItem?.map((item) => ({
      ...entity,
      idItemGift: item.itemId,
      itemGiftCode: item.itemCode,
      itemGiftName: item.itemName,
      attribute2: null,
    }));

    const addUniqueItems = (prevData: tblPromotionItemGiftCommand[]) => {
      const uniqueItemsMap = new Map<number, tblPromotionItemGiftCommand>();

      [...newData, ...prevData].forEach((item) => {
        if (item.idItemGift !== null) {
          uniqueItemsMap.set(item.idItemGift, item);
        }
      });
      return Array.from(uniqueItemsMap.values());
    };

    setData((prevData) => addUniqueItems(prevData));
    setDataTemp((prevData) => addUniqueItems(prevData));
    setRowCount((prevData) => prevData + selectItem.length);
    setSelectIds([]);
    table.resetRowSelection();
    modals.closeAll();
  };

  const appleDiscountToAll = (dataSubmit: {
    discountPercent: null;
    discountAmount: null;
    quantityMin: null;
    quantityMax: null;
  }) => {
    // setDataTemp((prevData) =>
    //   prevData.map((item) => ({ ...item, ...dataSubmit }))
    // );
    // setData((prevData) => prevData.map((item) => ({ ...item, ...dataSubmit })));

    const select = table.getSelectedRowModel().rows.map((row) => row.original);

    if (select.length > 0) {
      setDataTemp((prevData) =>
        prevData.map((item) => {
          const selectedItem = select.find(
            (selected) => selected.idItemGift === item.idItemGift
          );
          return selectedItem ? { ...item, ...dataSubmit } : item;
        })
      );
      setData((prevData) =>
        prevData.map((item) => {
          const selectedItem = select.find(
            (selected) => selected.idItemGift === item.idItemGift
          );
          return selectedItem ? { ...item, ...dataSubmit } : item;
        })
      );
    } else {
      setDataTemp((prevData) =>
        prevData.map((item) => ({ ...item, ...dataSubmit }))
      );
      setData((prevData) =>
        prevData.map((item) => ({ ...item, ...dataSubmit }))
      );
    }
    modals.closeAll();
    table.resetRowSelection();
  };

  const editItemDiscount = (dataSubmit: tblPromotionItemGiftCommand) => {
    setDataTemp((prevData) =>
      prevData.map((item) =>
        item.idItemGift === dataSubmit.idItemGift ? dataSubmit : item
      )
    );
    setData((prevData) =>
      prevData.map((item) =>
        item.idItemGift === dataSubmit.idItemGift ? dataSubmit : item
      )
    );

    modals.closeAll();
  };

  const deletesData = (ids: string[]) => {
    setDataTemp((prevData) =>
      prevData.filter(
        (item) => !ids.includes(item?.idItemGift?.toString() || "")
      )
    );
    setData((prevData) =>
      prevData.filter(
        (item) => !ids.includes(item?.idItemGift?.toString() || "")
      )
    );

    setSelectIds([]);
    table.resetRowSelection();
  };

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (465 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    form.setFieldValue("tblPromotionItemGiftCommands", dataTemp);
  }, [dataTemp]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: ({ table }) => (
      <div ref={headerRef}>
        <Flex
          gap="md"
          justify="flex-start"
          align="center"
          direction="row"
          wrap="wrap"
        >
          {/* <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                // await fetchData();
              }}
            >
              Lọc bảng giá
            </Button> */}
        </Flex>
      </div>
    ),
    renderToolbarInternalActions: ({ table }) => (
      <>
        <Flex
          gap="md"
          justify={"flex-end"}
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Button
            leftSection={<IconPlus size={14} />}
            color="blue"
            variant="outline"
            onClick={openSearchItems}
          >
            Thêm mới (F11)
          </Button>

          <Button
            leftSection={<IconTrash size={14} />}
            color="red"
            variant="outline"
            onClick={() => {
              deletesData(selectIds);
            }}
            disabled={selectIds.length < 1}
          >
            Xóa (đã chọn)
          </Button>

          <Button
            leftSection={<IconEdit size={14} />}
            color="green"
            variant="outline"
            onClick={() => openModalDiscountToAll()}
            disabled={data.length < 1}
          >
            Thiết lập chiết khấu
          </Button>
        </Flex>
      </>
    ),
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    enableRowVirtualization: true,
    enableBatchRowSelection: true,
    enablePagination: true,
    selectAllMode: "all",
    // rowVirtualizerOptions: { overscan: 8 },
    getRowId: (row) => row?.idItemGift?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: [
          "mrt-row-select",
          "apply",
          "itemGiftCode",
          "namePurchase",
          "nameManufacturer",
        ],
        right: ["allocationRate", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      showGlobalFilter: true,
    },
    enableGlobalFilter: true,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    // manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        // fontWeight: "bold",
        fontSize: "11px",
        padding: "4px 12px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      // showProgressBars: isRefetching,
      // showSkeletons: isLoading, //loading for the first time with no data
      //   sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: false,
    mantineTableProps: {
      striped: false,
    },
  });

  return <MantineReactTable table={table} />;
};

export default TableItemGiftPromotion;
